var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.10547C14.8869 2.10547 17.1761 3.05368 18.864 4.74151C20.5518 6.42933 21.5 8.71852 21.5 11.1055C21.5 14.1795 19.824 16.6955 18.058 18.5005C17.1755 19.3924 16.2128 20.2011 15.182 20.9165L14.756 21.2065L14.556 21.3395L14.179 21.5795L13.843 21.7845L13.427 22.0265C13.1445 22.1873 12.825 22.2718 12.5 22.2718C12.175 22.2718 11.8555 22.1873 11.573 22.0265L11.157 21.7845L10.637 21.4645L10.445 21.3395L10.035 21.0665C8.92298 20.3138 7.88707 19.4544 6.942 18.5005C5.176 16.6945 3.5 14.1795 3.5 11.1055C3.5 8.71852 4.44821 6.42933 6.13604 4.74151C7.82387 3.05368 10.1131 2.10547 12.5 2.10547ZM12.5 8.10547C12.106 8.10547 11.7159 8.18307 11.3519 8.33383C10.988 8.48459 10.6573 8.70557 10.3787 8.98415C10.1001 9.26272 9.87913 9.59344 9.72836 9.95742C9.5776 10.3214 9.5 10.7115 9.5 11.1055C9.5 11.4994 9.5776 11.8895 9.72836 12.2535C9.87913 12.6175 10.1001 12.9482 10.3787 13.2268C10.6573 13.5054 10.988 13.7263 11.3519 13.8771C11.7159 14.0279 12.106 14.1055 12.5 14.1055C13.2956 14.1055 14.0587 13.7894 14.6213 13.2268C15.1839 12.6642 15.5 11.9011 15.5 11.1055C15.5 10.3098 15.1839 9.54676 14.6213 8.98415C14.0587 8.42154 13.2956 8.10547 12.5 8.10547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.105469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a70c986f338c41a0e58c550d775d7ae9.svg";
export { ForwardRef as ReactComponent };